import InvestorGoalError from './InvestorGoalError';
class MissingAccountValue extends InvestorGoalError {
    constructor(options) {
        super('Missing account value', options);
    }
}
export default MissingAccountValue;
